__turbopack_context__.v({
  "lineHeightLoose": "D0Nh0q_lineHeightLoose",
  "lineHeightNormal": "D0Nh0q_lineHeightNormal",
  "lineHeightRelaxed": "D0Nh0q_lineHeightRelaxed",
  "lineHeightSnug": "D0Nh0q_lineHeightSnug",
  "lineHeightTight": "D0Nh0q_lineHeightTight",
  "list": "D0Nh0q_list",
  "markerDash": "D0Nh0q_markerDash",
  "spacingCompact": "D0Nh0q_spacingCompact",
  "spacingNormal": "D0Nh0q_spacingNormal",
  "spacingRelaxed": "D0Nh0q_spacingRelaxed",
  "textL": "D0Nh0q_textL",
  "textM": "D0Nh0q_textM",
  "textS": "D0Nh0q_textS",
  "textXL": "D0Nh0q_textXL",
  "textXS": "D0Nh0q_textXS",
  "textXXL": "D0Nh0q_textXXL",
  "textXXS": "D0Nh0q_textXXS",
});
